module.exports = __webpack_public_path__ + "img/007.8ebbc9f2.svg";